import React, { FC, useState, useEffect } from "react";
import Spinner from "../../Spinner/Spinner";
import {
  fetchMyRepositories,
  fetchSearchRepositorys,
} from "../../../redux/slices/RepositorysSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/store/store";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import "./ListMeRepositories.css";
import { updateSessionToken } from "../../../redux/slices/UpdateSessionTokenSlice";
import { refreshToken2 } from '../../../refreshToken2';
import { useMsal } from '@azure/msal-react';
import RepositoryContent from "../../../pages/RepositoryContent/RepositoryContent";
import { useNavigate } from "react-router-dom";
import { WindowsBuildImage } from "aws-cdk-lib/aws-codebuild";
import { isNotEmpty } from "../../../Helpers/Http.commons";

const ListMeRepositories = () => {
  const navigate = useNavigate();
  const sessionToken = useAppSelector((state) => state.session.sessionToken);
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [showFilters, setShowFilters] = useState(false);
  const [repositoryName, setRepositoryName] = useState("");
  const [repositoryvalue, setRepositoryValue] = useState(false);
  const totalPages = ((sessionStorage.getItem('total-pages') != null) ? +sessionStorage.getItem('total-pages')! : 0);
  const { instance } = useMsal();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadContent();
    setLoading(false);
  }, [take]);

  const loadContent = async () => {
    await refreshToken2(instance);
    await dispatch(fetchMyRepositories({ Page: page, Take: take }));
  };

  

  const handlePageChange = (Page: number) => {
    if(Page >0 && Page <= totalPages){
      setPage(Page);
      // console.log("Este es el Page:", Page);
      dispatch(fetchMyRepositories({ Page: Page, Take: take }));
    }
  };
  const handleTakeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();
    const newTake = Number(event.target.value);
    setTake(newTake);
    // setPage(1);
    // console.log("Este es el Take:", newTake);
    dispatch(fetchMyRepositories({ Page: page, Take: newTake }));
  };
  const handleOnBlur = () => {
    if (!repositoryName) {
      dispatch(fetchMyRepositories({ Page: page, Take: take }));
    }
  };
  const GetRepositoryByName = (repositoryName: any) => {
    console.log("GetRepositoryByName:", repositoryName);
    dispatch(fetchSearchRepositorys(repositoryName));
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      GetRepositoryByName(repositoryName);
    }
  };
  const ShowData = async (data: {
    repositoryName: string;
    repositoryId: string;
  }) => {
    const repositoryName = data.repositoryName.replace(/"/g, "");
    const repositoryId = data.repositoryId;
    sessionStorage.setItem("repositoryId", repositoryId);
    sessionStorage.setItem("repositoryName", repositoryName);
    await new Promise((resolve) => setTimeout(resolve, 0)); // Esperar a que se establezcan los valores de sesión
    console.log(
      "============ REDIRECT LOG: [ListMeRepositories] - Navigate to /documents"
    );
    navigate("/documents");
    window.location.reload();
    console.log("repositoryvalue listmerepositories:", repositoryvalue);
  };

  const result: {
    id: string;
    name: string;
    description: string;
    businessUnitId: string;
    filters: any[];
  }[] = useAppSelector((state) => state.RepositorysSlice.result);
  const resultsearch: {
    id: string;
    name: string;
    description: string;
    businessUnitId: string;
    filters: any[];
  }[] = useAppSelector((state) => state.RepositorysSlice.result);

  console.log("este es el result",result); 

  return  loading ? <Spinner/>: (
    <div className="tablemerepositories">
      <div className="pds-dataTable pds-dataTable-flexible table-merepositories">
        <div className="pds-dataTable-header">
          <p
            aria-hidden="true"
            className="pds-dataTable-title pds-typography-eyebrow-1"
          >
            Mis Repositorios
          </p>
          <div className="pds-searchInput pds-dataTable-smart-search">
            <input
              aria-label="Filter table data search bar"
              className="search inputSearch pds-input-small"
              type="search"
              onChange={(e) => setRepositoryName(e.target.value)}
              onBlur={handleOnBlur}
              onKeyDown={handleKeyDown}
              placeholder="Busqueda por nombre de repositorio"
            />
            <button
              type="submit"
              aria-label="Search"
              onClick={() => GetRepositoryByName(repositoryName)}
              aria-disabled="true"
            />
          </div>
        </div>
        <div className="pds-dataTable-table-container pds-table-scrolling ">
          <table
            className="pds-table-container pds-table pds-table-bordered tablerepo"
            id="pds-datatable-flexible-example"
            aria-live="polite"
          >
            <thead>
              <tr>
                {/* <th className="sort  title-header pds-typography-eyebrow-2" scope="col">&nbsp;&nbsp;Id de Repositorio</th> */}
                <th
                  className="sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                >
                  &nbsp;&nbsp;Nombre del Repositorio
                </th>
                <th
                  className="sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                >
                  &nbsp;&nbsp;&nbsp;Descripcion
                </th>
                <th
                  className="sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                  colSpan={2}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Accion
                </th>
              </tr>
            </thead>
            {isNotEmpty(result) &&
              Object.values(result)
                .map((repository, index) => (
                  <tbody key={repository.id}>
                    <tr key={index}>
                      {/* <td className="pds-dataTable-table-item">{repository.id}</td> */}
                      <td className="pds-dataTable-table-item">
                        {repository.name}
                      </td>
                      <td className="pds-dataTable-table-item">
                        {repository.description}
                      </td>
                      <td className="pds-tableActionMenu-actionColumn">
                        <button
                          className="pds-button pds-button-primary"
                          onClick={() =>
                            ShowData({
                              repositoryName: repository.name,
                              repositoryId: repository.id,
                            })
                          }
                        >
                          Ver Contenido
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))}
          </table>
        </div>
        <div className="pds-dataTable-footer">
          <div className="pds-dataTable-show-entries">
            <label className="pds-dataTable-select-label" />
            <div className="pds-select">
            <select
                    id=""
                    aria-label="Number of rows to display in table" name="entries" className="pds-dataTable-select-options pds-select-small"
                    value={take}
                    onChange={handleTakeChange}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
            </div>
            
          </div>
          <nav
                aria-label="Pagination"
                className="pds-pagination pds-dataTable-pagination"
              >
                <span className="pds-dataTable-previous-buttons pds-dataTable-disable-pagination-buttons">
                  <a
                    role="link"
                    tabIndex={0}
                    aria-label="first page"
                    aria-disabled={page === 1}
                    className={`pds-dataTable-first-page pds-pagination-fly-first page pds-pagination-link ${page === 1 ? 'disabled' : ''
                      }`}
                    onClick={() => handlePageChange(1)}
                  />
                  <a
                    role="link"
                    tabIndex={0}
                    aria-label="Previous page"
                    aria-disabled={page === 1}
                    className={`pds-dataTable-previous pds-pagination-step-forward page pds-pagination-link ${page === 1 ? 'disabled' : '' }`}
                    onClick={() => handlePageChange(page - 1)} />
                </span>
                <span className="pds-dataTable-next-buttons">
                  <a
                    role="link"
                    tabIndex={0}
                    aria-label="Next page"
                    className={`pds-dataTable-next pds-pagination-step-backward page pds-pagination-link ${page === totalPages ? 'disabled' : '' }`}
                    onClick={() => handlePageChange(page + 1)}
                  />
                  <a
                    role="link"
                    tabIndex={0}
                    aria-label="Last page"
                    className={`pds-dataTable-last-page pds-pagination-fly-last page pds-pagination-link ${page === totalPages ? 'disabled' : '' }`}
                    onClick={() => handlePageChange(totalPages)}
                  />
            </span>
          </nav>
        </div>
      </div>
    </div>
  )
}
export default ListMeRepositories;
